<template>
    <div class="container">
        <section
            class="row"      
        >
            <div class="col-md-12 d-sm-flex d-block no-gutters pl-3"><!--Bkup: col-lg-10 offset-lg-1 d-sm-flex d-block no-gutters pl-3"-->
                <div class="container pl-0">
                    <h1>Film Permit Application</h1>
                    <div class="row mt-5 pl-3" >
                        <div class="d-flex flex-wrap mr-5 mb-2 pr-3">
                            <span class="mt-2 mr-3 license-icon">
                                <SvgIconFilePlus />
                            </span>
                            <a
                                href="javascript:void(0)" @click="ApplicationForm('permit')"
                            >
                                <u class="applyNewPermit">
                                New film permit<br />
                                application 
                                <i class="far fa-question-circle" v-b-popover.hover.right="{ variant: 'info',  content: 'Required for filming on City property such as sidewalks, parks and facilities.' }" ></i>
                                </u>
                            </a>
                        </div>
                        <!-- Grid application -->
                        <div class="d-flex flex-wrap mb-2">
                            <span class="mt-2 mr-3 mb-2 license-icon">
                                <SvgIconFilePlus />
                            </span>
                            <a href="javascript:void(0)" @click="ApplicationForm('grid')">
                                <u class="applyNewPermit">
                                New grid (city all)<br />
                                permit application 
                                <!--<i class="far fa-question-circle" v-b-popover.hover.right="'Required for camera-in-car filming with the flow of traffic on City roadways.'" ></i>-->
                                <i class="far fa-question-circle" v-b-popover.hover.right="{ variant: 'info',  content: 'Required for camera-in-car filming with the flow of traffic on City roadways.' }" ></i>
                                </u>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

        </section>
        
        <div v-if="$store.getters.isLoading" class="loading-box col-md-12">
            <div class="spinner"></div>
            <div class="title">Loading...</div>
            <div class="text" v-if="$store.getters.loadingMsg">
                {{ $store.getters.loadingMsg }}
            </div>
        </div>

        <!--TOTEST: for line below v-if="formSaveDataList.length > 0"
                    :savedApplications="formSaveDataList"
        -->
        <SavedApplications v-if="formSaveDataList.length > 0" 
            :savedApplications="formSaveDataList"
            >
        </SavedApplications>

    </div>
</template>

<script>
import { mapState } from "vuex";  //mapActions,
import SavedApplications from '@/components/SavedApplications.vue';
import SvgIconFilePlus from "@/components/Svg/SvgIconFilePlus";
//import SvgIconCloudArrowUp from "@/components/Svg/SvgIconCloudArrowUp";

export default {
    name: "Dashboard",
    components: { 
        SavedApplications,
        SvgIconFilePlus,
        //SvgIconCloudArrowUp
        },
    computed: {
        formType: {
            get() {
                return this.$store.getters.formType;
            },
            set(val) {
                this.$store.dispatch('SET_TYPE', val);
            },
        },
        //TOTEST:
        ...mapState(['formSaveDataList'])
	},
    methods:{
        ApplicationForm(formType)
        {
            this.$store.dispatch('RESETSTATE_VALUE',{name:'steps',type: 'stepsObj'})
            this.$store.dispatch('SETSTATE_VALUE', {name:'savedAppId',value: 0});
            this.$store.dispatch('RESET_FORM');
            this.$store.dispatch("RESETSTATE_VALUE",{name:'savedAppValidationList', type:'ArrayTypes'})
            //if(formType=="permit")
                //this.$store.dispatch('SET_LATEST_COMPLETED_STEP');        
            this.$store.dispatch('SET_TYPE', formType);
            this.$router.push({ name: "New application" })
        },
    },
    mounted()
    {
        //TOTEST:
        this.$store.dispatch("RETRIEVE_SAVEDFORMDATA");  
           
        if(this.$route.params.status=="copied")
        {
            alert('copied');
            window.location.reload(); 
        }
        else if(this.$route.params.status=="deleted")
        {
            alert('deleted');
            window.location.reload(); 
        }
    }
};
</script>
